import { render, staticRenderFns } from "./CampaignDesigner.vue?vue&type=template&id=27476bec&scoped=true&"
import script from "./CampaignDesigner.vue?vue&type=script&lang=js&"
export * from "./CampaignDesigner.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDesigner.vue?vue&type=style&index=0&id=27476bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27476bec",
  null
  
)

export default component.exports